import { Component } from 'react';
import { PHARMA_APP_URL } from '../../config';

class RedirectToPharmaApp extends Component {
    componentDidMount() {
        window.location.replace(PHARMA_APP_URL);
    }

    render() {
        return null;
    }
}

export default RedirectToPharmaApp;
